import StopTimesCell from './component';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const fields = ['time_from', 'time_to'];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const { time_from: timeFrom, time_to: timeTo } = props.selectors.getJourneyStopFields(
      state,
      props.journeyId,
      props.stopId,
      fields
    );
    return {
      timeFrom,
      timeTo,
    };
  })
);

export default enhance(StopTimesCell);
